// extracted by mini-css-extract-plugin
module.exports = {"list":"PackagesList_list__X01x0","listSmaller":"PackagesList_listSmaller__piNcT"};